<!-- 中转页面 -->
<template>
  <div class="content"
       v-loading="isUploading"
       element-loading-text="上传中..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(255, 255, 255, 0.8)">
    <!-- 创建新项目 -->
    <div class="project"
         v-if="type==1">
      <el-card class="box-card">
        <div class="createProject">
          <div class="title">创建新项目</div>
          <div class="text">填写项目基本信息开始您的工作</div>
        </div>
        <el-form label-position="top"
                 :rules="createRules"
                 ref="createRuleForm"
                 :inline="true"
                 label-width="80px"
                 :model="createProjectList">
          <el-row>
            <el-col :span="12">
              <el-form-item label="项目名称"
                            prop="name"
                            style="width:95%">
                <el-input v-model="createProjectList.name"
                          placeholder="请输入项目名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="开始时间"
                            style="width:95%">
                <el-date-picker v-model="createProjectList.startTime"
                                type="month"
                                style="width: 100%;"
                                placeholder="-/-">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="结束时间"
                            style="width:95%">
                <el-date-picker v-model="createProjectList.endTime"
                                type="month"
                                style="width: 100%;"
                                placeholder="-/-">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="项目备注"
                        style="display: block;">
            <el-input type="textarea"
                      placeholder="请输入项目相关备注信息（选填）"
                      v-model="createProjectList.introduction"
                      maxlength="500"
                      show-word-limit>
            </el-input>

          </el-form-item>
        </el-form>
        <span class="dialog-footer">
          <el-button @click="resetAddProject('createRuleForm')">取 消 创 建</el-button>
          <el-button style="background-color: #145fad; color: white; border-color: #fff;"
                     @click="addProject('createRuleForm')">创 建 项 目</el-button>
        </span>
      </el-card>
    </div>

    <!-- 项目文件上传 -->
    <div class="project"
         v-if="type==2">
      <el-card class="box-card">
        <div class="createProject">
          <div class="title">项目文件上传</div>
          <div class="text">请上传数据表格</div>
        </div>
        <el-card class="card-dataTable">
          <div class="step1">上传数据表格</div>
          <div class="step2">
            <div class="left">
              <div class="title">下载模版</div>
              <div class="text">请先下载并按照模版格式填写数据</div>
            </div>
            <div class="right">
              <el-button style="background-color: #145fad; color: white; border-color: #fff;"
                         icon="el-icon-download"
                         size="small"
                         @click="downloadImportTemplate()">下载模版文件</el-button>
            </div>
          </div>
          <div class="step3">
            <i class="header-icon el-icon-info"></i>查看模版填写说明
          </div>
          <div class="upload">
            <el-upload class="upload-demo"
                       drag
                       :auto-upload="false"
                       :before-upload="tableBeforeUpload"
                       :on-change="tableHanlechange"
                       :on-remove="tableHandleRemove"
                       ref="tableUpload"
                       action="http://dev.db.tynsr.com/brain/order/importSample"
                       :multiple="false"
                       :limit="1"
                       accept=".xlsx,.csv"
                       style="width: 100%;">
              <i class="el-icon-upload"
                 style="font-size:40px;margin: 24px 0 16px;"></i>
              <div><el-button slot="trigger"
                           style="background-color: #f08813; color: white; border-color: #fff;"
                           icon="el-icon-plus"
                           type="primary">选择表格文件</el-button></div>
              <div class="el-upload__text">或将文件拖拽到此处</div>
            </el-upload>
          </div>
        </el-card>
        <el-card class="format">
          <div class="title">文件格式说明</div>
          <div class="text"><i class="el-icon-check"></i>支持的文件格式：Excel(.xlsx)或 CSV(.csv)</div>
          <div class="text"><i class="el-icon-check"></i>文件大小限制：不超过100MB</div>
        </el-card>
        <span class="dialog-footer">
          <el-button @click="cancelUpload()">取 消 上 传</el-button>
          <el-button style="background-color: #145fad; color: white; border-color: #fff;"
                     :loading="isUploading"
                     :disabled="isUploading"
                     @click="importSample">开 始 上 传</el-button>
        </span>
      </el-card>
    </div>

    <!-- 上传原始文件 -->
    <div class="project"
         v-if="type==3">
      <el-card class="box-card">
        <div class="createProject">
          <div class="title">项目文件上传</div>
          <div class="text">请上传原始文件</div>
        </div>
        <el-card class="card-dataTable">
          <div class="step1">上传原始文件</div>
          <div class="upload">
            <el-upload class="upload-demo"
                       drag
                       :auto-upload="false"
                       :before-upload="originalBeforeUpload"
                       :on-change="originalHanlechange"
                       :on-remove="originalHandleRemove"
                       :multiple="false"
                       :limit="1"
                       action=""
                       ref="originalUpload"
                       accept=".zip"
                       style="width: 100%;">
              <div style="margin: 30px 0 16px;">
                <i :class="'iconfont icon-shangchuanwenjian-xian-copy'"
                   style="font-size:40px;color: #999;"></i>
              </div>
              <div><el-button slot="trigger"
                           style="background-color: #145fad; color: white; border-color: #fff;"
                           icon="el-icon-plus"
                           type="primary">选择原始文件</el-button></div>
              <div class="el-upload__text">仅支持 .zip，单个文件不超过100MB</div>
            </el-upload>
          </div>
        </el-card>
        <span class="dialog-footer">
          <el-button @click="cancelUpload()">取 消 上 传</el-button>
          <el-button style="background-color: #145fad; color: white; border-color: #fff;"
                     :loading="isUploading"
                     :disabled="isUploading"
                     @click="importSampleFile">开 始 上 传</el-button>
        </span>
      </el-card>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isUploading: false,
      tableFile: '',
      originalFile: '',
      projectId: '',
      type: '',
      createProjectDialogVisible: false,
      createProjectList: {
        name: '',
        startTime: '',
        endTime: '',
        introduction: ''
      },
      createRules: {
        name: [{ required: true, message: '请输入项目名称', trigger: 'blur' }]
      }
    }
  },

  mounted() {
    this.type = this.$route.query.type
    this.projectId = this.$route.query.projectId
  },

  methods: {
    // 创建项目
    addProject(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          const { data: res } = await this.$http.post('/brain/project/addProject', this.createProjectList)
          if (res.code == 200) {
            this.$message({
              message: '创建项目成功',
              type: 'success'
            })
            this.$router.back()
          } else {
            this.$message.error(res.msg)
          }
          this.$refs[formName].resetFields()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 重置创建项目表单
    resetAddProject(formName) {
      this.$router.back()
      this.$refs[formName].resetFields()
    },
    cancelUpload() {
      this.$router.back()
    },
    // 下载模版文件
    async downloadImportTemplate() {
      const { data: res } = await this.$http.get('/brain/sample/downloadImportTemplate', { responseType: 'blob' })
      const blob = new Blob([res])
      let a = document.createElement('a')
      a.style.display = 'none'
      a.download = `模版文件.xlsx`
      a.href = URL.createObjectURL(blob)
      document.body.appendChild(a)
      a.click()
    },
    tableBeforeUpload(file) {
      console.log(file)
    },
    tableHanlechange(file) {
      this.tableFile = file.raw
    },
    tableHandleRemove(file) {
      this.tableFile = ''
    },
    originalBeforeUpload(file) {
      const name = (file && (file.name || file.raw?.name || '')).toLowerCase()
      const ext = name.split('.').pop()
      const ok = ext === 'zip'
      if (!ok) {
        this.$message.error('仅支持 .zip 文件')
        if (this.$refs.originalUpload) this.$refs.originalUpload.clearFiles()
        return false
      }
      return true
    },
    originalHanlechange(file) {
      const name = (file && (file.name || file.raw?.name || '')).toLowerCase()
      const ext = name.split('.').pop()
      const ok = ext === 'zip'
      if (!ok) {
        this.$message.error('仅支持 .zip 文件')
        if (this.$refs.originalUpload) this.$refs.originalUpload.clearFiles()
        this.originalFile = ''
        return
      }
      this.originalFile = file.raw
    },
    originalHandleRemove(file) {
      this.originalFile = ''
    },
    async importSample() {
      var tableFormData = new FormData()
      if (this.tableFile) {
        tableFormData.append('projectId', this.projectId)
        tableFormData.append('file', this.tableFile)
        let res
        this.isUploading = true
        try {
          const response = await this.$http.post(`/brain/sample/importSample`, tableFormData)
          res = response && response.data
        } catch (e) {
          this.$message.error('数据表格上传失败，请稍后重试')
          return
        } finally {
          this.isUploading = false
        }
        if (res.code == 200) {
          const duplicateRows = res.data && typeof res.data.duplicateRows === 'number' ? res.data.duplicateRows : 0
          const total = res.data && typeof res.data.total === 'number' ? res.data.total : 0
          const duplicateNumberList = res.data && Array.isArray(res.data.duplicateNumberList) ? res.data.duplicateNumberList : []
          const allNumberList = res.data && Array.isArray(res.data.allNumberList) ? res.data.allNumberList : []
          this.tableFile = ''
          const html = duplicateRows > 0 ? `<div>您本次导入了${total}条数据，包含了${duplicateRows}条重复数据</div>` : `<div>找到${total}条有效数据</div>`
          if (duplicateRows > 0) {
            await this.confirmDuplicateImport({
              html,
              duplicateNumberList,
              allNumberList
            })
          } else {
            await this.confirmNoDuplicateImport({
              html,
              duplicateNumberList,
              allNumberList
            })
          }
        } else {
          return this.$message.error(`数据表格:${res.msg}`)
        }
      } else {
        return this.$message.error('请先上传数据！')
      }
    },
    async submitImportSample({ isAddRepeat, duplicateNumberList, allNumberList, isCancelImport }) {
      const payload = {
        isAddRepeat: !!isAddRepeat,
        duplicateNumberList: Array.isArray(duplicateNumberList) ? duplicateNumberList : [],
        allNumberList: Array.isArray(allNumberList) ? allNumberList : [],
        projectId: this.projectId,
        isCancelImport: !!isCancelImport
      }
      let res
      this.isUploading = true
      try {
        const response = await this.$http.post('/brain/sample/submitImportSample', payload)
        res = response && response.data
      } catch (e) {
        this.$message.error('提交导入失败，请稍后重试')
        return
      } finally {
        this.isUploading = false
      }
      if (res.code == 200) {
        if (payload.isCancelImport) {
          this.$message({
            type: 'error',
            message: '已取消导入'
          })
        } else {
          this.$message({
            type: 'success',
            message: '导入提交成功!'
          })
        }
        this.resetTableUpload()
      } else {
        this.$message.error(res.msg || '提交导入失败')
      }
    },
    resetTableUpload() {
      this.tableFile = ''
      if (this.$refs.tableUpload) this.$refs.tableUpload.clearFiles()
    },
    async confirmDuplicateImport({ html, duplicateNumberList, allNumberList }) {
      const content = `${html}<div style="margin-top:10px;color:#606266;">请选择导入方式</div>`
      try {
        await this.$confirm(content, '提示', {
          confirmButtonText: '忽略重复数据并导入',
          cancelButtonText: '添加重复数据并导入',
          dangerouslyUseHTMLString: true,
          distinguishCancelAndClose: true,
          closeOnClickModal: false
        })
        await this.submitImportSample({
          isAddRepeat: false,
          duplicateNumberList,
          allNumberList,
          isCancelImport: false
        })
      } catch (action) {
        if (action === 'cancel') {
          await this.submitImportSample({
            isAddRepeat: true,
            duplicateNumberList,
            allNumberList,
            isCancelImport: false
          })
          return
        }
        const isCancelImport = await this.confirmCancelImport()
        if (isCancelImport) {
          await this.submitImportSample({
            isAddRepeat: false,
            duplicateNumberList,
            allNumberList,
            isCancelImport: true
          })
          return
        }
        await this.$nextTick()
        await new Promise((resolve) => setTimeout(resolve, 200))
        await this.confirmDuplicateImport({
          html,
          duplicateNumberList,
          allNumberList
        })
      }
    },
    async confirmNoDuplicateImport({ html, duplicateNumberList, allNumberList }) {
      try {
        await this.$confirm(html, '提示', {
          confirmButtonText: '导入',
          showCancelButton: false,
          dangerouslyUseHTMLString: true,
          distinguishCancelAndClose: true,
          closeOnClickModal: false
        })
        await this.submitImportSample({
          isAddRepeat: false,
          duplicateNumberList,
          allNumberList,
          isCancelImport: false
        })
      } catch (action) {
        const isCancelImport = await this.confirmCancelImport()
        if (isCancelImport) {
          await this.submitImportSample({
            isAddRepeat: false,
            duplicateNumberList,
            allNumberList,
            isCancelImport: true
          })
          return
        }
        await this.$nextTick()
        await new Promise((resolve) => setTimeout(resolve, 200))
        await this.confirmNoDuplicateImport({
          html,
          duplicateNumberList,
          allNumberList
        })
      }
    },
    async confirmCancelImport() {
      try {
        await this.$confirm('是否取消本次导入？', '提示', {
          confirmButtonText: '取消导入',
          cancelButtonText: '继续导入',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          distinguishCancelAndClose: true,
          showClose: false
        })
        return true
      } catch (e) {
        return false
      }
    },
    async importSampleFile() {
      var originalFormData = new FormData()
      if (this.originalFile) {
        const name = this.originalFile.name?.toLowerCase() || ''
        const ext = name.split('.').pop()
        if (!(ext === 'zip')) {
          this.$message.error('仅支持 .zip 文件')
          return
        }
        originalFormData.append('projectId', this.projectId)
        originalFormData.append('file', this.originalFile)
        let res
        this.isUploading = true
        try {
          const response = await this.$http.post(`/brain/sampleFile/importSampleFile`, originalFormData)
          res = response && response.data
        } catch (e) {
          this.$message.error('原始文件上传失败，请稍后重试')
          return
        } finally {
          this.isUploading = false
        }
        if (res.code == 200) {
          this.originalFile = ''
          this.$message({
            type: 'success',
            message: '上传原始文件成功!'
          })
        } else {
          return this.$message.error(`原始文件:${res.msg}`)
        }
      } else {
        return this.$message.error('请先上传数据！')
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.content {
  .project {
    width: 80%;
    padding-bottom: 80px;
    margin: auto;
    padding-top: 30px;
    .box-card {
      border-radius: 10px;
      .createProject {
        text-align: center;
        .title {
          font-weight: 600;
          font-size: 23px;
          color: #1962af;
        }
        .text {
          margin-top: 15px;
          margin-bottom: 10px;
          color: #9097a0;
        }
      }
      .card-dataTable {
        border-radius: 10px;
        background-color: #f9fafb;
        .step1 {
          color: black;
          font-weight: 600;
        }
        .step2 {
          margin-top: 20px;
          display: flex;
          justify-content: space-between;
          .left {
            .title {
              color: black;
              font-weight: 600;
            }
            .text {
              margin-top: 10px;
              font-size: 13px;
              color: #9097a0;
            }
          }
        }
        .step3 {
          margin-top: 20px;
          color: #9097a0;
          font-size: 13px;
          .el-icon-info {
            margin-right: 5px;
          }
        }
        .upload {
          width: 100%;
          margin: 20px 0px;
          .upload-demo {
            width: 100%;
            .el-upload__text {
              padding-top: 10px;
              color: #aaaeb6;
            }
          }
        }
      }
      .format {
        margin-top: 20px;
        border-radius: 10px;
        background-color: #f9fafb;
        .title {
          color: #000;
          font-weight: 600;
        }
        .text {
          color: #a5aab1;
          margin-top: 15px;
          .el-icon-check {
            color: #1962af;
            font-weight: 600;
            margin-right: 5px;
          }
        }
      }
      .divider {
        margin: 50px 0px;
      }
      .dialog-footer {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
      }
    }
  }
  ::v-deep.el-upload {
    width: 100% !important;
  }
  ::v-deep.el-upload-dragger {
    width: 100% !important;
    background-color: #f9fafb;
  }
}
</style>
